<div class="feedback-dialog">
  <div class="headline-6 feedback-title">Feedback</div>
  <mat-dialog-content class="feedback-dialog-content">
    <p class="body-2 feedback-copy">Dear User,<br />Your thoughts are valuable in helping improve our services.</p>
    <form #feedbackForm="ngForm" class="feedback-form">
      <div class="feedback-form-field">
        <ra-ui-select
          #feedbackType="ngModel"
          name="feedbackType"
          required
          ngModel
          [items]="feedbackTypeOptions"
          [config]="{ fillParent: true, adaptMenuWidthToControl: true }"
          [errorMessages]="{ required: 'Feedback Option is required' }"
          label="Select Feedback Type*"
        ></ra-ui-select>
      </div>
      <div class="feedback-form-field">
        <ra-ui-multiline-input
          #feedbackText
          ngModel
          label="Please share your feedback with us.*"
          [config]="{
            isAutoSizeTextArea: false,
            fillParent: true,
            removeMessageSpace: false,
            minRows: 1,
            maxRows: 15,
            maxLength: 1000,
          }"
          [hintMessageEnd]="getInputHint(feedbackText.value, 1000)"
          [errorMessages]="{ required: 'Feedback is required', maxlength: 'Only 1000 characters allowed' }"
          name="feedbackText"
          ngDefaultControl
          required
        ></ra-ui-multiline-input>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="feedback-modal-action-container">
    <ra-ui-main-button label="Send" [disabled]="!feedbackForm.valid" (click)="sendFeedback()"> </ra-ui-main-button>
    <ra-ui-outlined-button label="Cancel" (click)="cancel()"></ra-ui-outlined-button>
  </mat-dialog-actions>
</div>
